var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div><message-icon ng-hide=\"$ctrl.$session.isAuthenticated\" message=\"Please sign in\" login-prompt=\"emun\" class=\"cursor-pointer\" type=\"warning\" icon=\"lock\"></message-icon><div ng-hide=\"!$ctrl.$session.isAuthenticated\" class=\"ng-cloak\"><ui-view></ui-view></div></div>";
var id1="credit-request-container.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;